import * as React from "react";
import { useEffect, useMemo } from "react";
import { useSearchParams, Link as RouterLink } from "react-router-dom";
import {
    Box,
    Card,
    CardContent,
    CardActions,
    Typography,
    Button,
    Stack
} from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import HourglassBottomRoundedIcon from "@mui/icons-material/HourglassBottomRounded";

export default function CheckoutFinalizado() {
    const [params] = useSearchParams();
    const status = (params.get("status") || "").toLowerCase(); // success | cancel | expired

    const cfg = useMemo(() => {
        switch (status) {
            case "success":
                return {
                    color: "success.main",
                    Icon: CheckCircleRoundedIcon,
                    title: "Pagamento confirmado",
                    subtitle:
                        "Tudo certo! Sua assinatura foi registrada. Você já pode fechar esta aba."
                };
            case "cancel":
                return {
                    color: "warning.main",
                    Icon: CancelRoundedIcon,
                    title: "Pagamento cancelado",
                    subtitle:
                        "Você cancelou a operação. Se preferir, tente novamente a qualquer momento."
                };
            case "expired":
                return {
                    color: "error.main",
                    Icon: HourglassBottomRoundedIcon,
                    title: "Link expirado",
                    subtitle:
                        "Este link de checkout expirou. Inicie uma nova tentativa para prosseguir."
                };
            default:
                return {
                    color: "primary.main",
                    Icon: HourglassBottomRoundedIcon,
                    title: "Processando",
                    subtitle:
                        "Estamos finalizando o processamento. Você pode fechar esta aba com segurança."
                };
        }
    }, [status]);

    // Fecha automaticamente se a aba foi aberta por window.open (opcional e suave)
    useEffect(() => {
        const canClose = !!window.opener; // foi aberta a partir da sua app
        if (!canClose) return;
        const t = setTimeout(() => {
            try {
                window.close();
            } catch { }
        }, 2500);
        return () => clearTimeout(t);
    }, [status]);

    const { Icon } = cfg;

    return (
        <Box
            minHeight="100vh"
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ p: 2 }}
        >
            <Card
                sx={{
                    width: "100%",
                    maxWidth: 520,
                    borderRadius: 3,
                    boxShadow: 6
                }}
            >
                <CardContent>
                    <Stack spacing={2} alignItems="center" textAlign="center">
                        <Box
                            sx={{
                                width: 64,
                                height: 64,
                                borderRadius: "50%",
                                bgcolor: (theme) => theme.palette.action.hover,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        >
                            <Icon sx={{ fontSize: 36, color: cfg.color }} />
                        </Box>

                        <Typography variant="h5" fontWeight={700}>
                            {cfg.title}
                        </Typography>

                        <Typography variant="body1" color="text.secondary">
                            {cfg.subtitle}
                        </Typography>
                    </Stack>
                </CardContent>

                <CardActions sx={{ p: 2, pt: 0, justifyContent: "center" }}>
                    <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} sx={{ width: "100%" }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                try {
                                    window.close();
                                } catch { }
                            }}
                            fullWidth
                        >
                            Fechar esta aba
                        </Button>
                        <Button
                            variant="outlined"
                            component={RouterLink}
                            to="/planejamento"
                            fullWidth
                        >
                            Voltar ao aplicativo
                        </Button>
                    </Stack>
                </CardActions>
            </Card>
        </Box>
    );
}